// Ukrainian (Українська) — answering-page strings only. Guests answering a survey in Ukrainian see
// the navigation and validation chrome in their language; everything outside the answering flow
// falls back to English (fallbackLng). Extend as needed.
export default {
    "You can select up to {count} options": "Можна вибрати не більше {count} варіантів",
    "Please answer all required questions to continue": "Будь ласка, дайте відповідь на всі обов’язкові питання, щоб продовжити",
    "Next Section": "Наступний розділ",
    "Previous Section": "Попередній розділ",
    "Next Question": "Наступне питання",
    "Previous Question": "Попереднє питання",
    "Complete": "Завершити",
    "Please enter all field properly": "Будь ласка, заповніть усі поля правильно",
    "This question is required": "Це питання є обов'язковим",
    "Choose": "Оберіть",
    "Other option": "Інший варіант",
    "Read more": "Читати більше",
    "Show less": "Згорнути",
    "Loading": "Завантаження",
};
